export const DietSizeMatrices = (json: IDietSizeMatrice): IDietSizeMatriceModel => {
	const { meal_size_id, meal_type, kcal, updated_at, created_at, ...rest } = json

	return {
		...rest,
		mealType: meal_type,
		mealSizeId: Number(meal_size_id),
		kcal: kcal ?? 0,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}
